export const getUserToken = () => {
  let token = null;
  const vuexAppState = JSON.parse(localStorage.getItem('quantum-app'));
  if (vuexAppState) {
    token = vuexAppState.app.user.token;
  }

  if (!token) {
    token = localStorage.getItem('token');
  }

  return token;
};
